import HTMLImg from './html_img'
export default HTMLImg



// WEBPACK FOOTER //
// ./src/playbacks/html_img/index.js